import axios, {AxiosRequestHeaders, AxiosResponse} from 'axios'
import {ID} from '../../../../../../_metronic/helpers'
import {CompaniesQueryResponse, Company, CreateCompanyBody} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const USER_URL = `${API_URL}/user`
const COMPANY_URL = `${API_URL}/company`
const GET_ALL_COMPANY_URL = `${API_URL}/company/all`

const tranformResponse = (company: any): Company => {
  return {
    companyId: company?.company_id,
    companyName: company?.company_name,
    incorporationDate: company?.incorporation_date,
    fyStartDate: company?.fy_start_date,
    reportingCurrency: company?.reporting_currency,
    companyAddress: {
      address: company?.address,
      pinCode: company?.postal_code,
      country: company?.country,
      state: company?.state,
      city: company?.city,
    },
    telephone: company?.phone_number,
    emailId: company?.email,
    website: company?.website_url,
    cin: company?.cin,
    gstNumber: company?.gst_in,
    lastTransactedAt: company?.last_transacted_at,
    fyList: company?.fy_list,
    logo: company?.logo,
  }
}

const getCompanies = async (query: string): Promise<CompaniesQueryResponse> => {
  return await axios
    .get(`${GET_ALL_COMPANY_URL}?${query}`, {
      validateStatus: () => true,
    })
    .then((d: AxiosResponse<CompaniesQueryResponse>) => d.data)
}

const getCompanyById = async (id: ID): Promise<Company | undefined> => {
  return await axios
    .get(`${COMPANY_URL}/${id}`)
    .then((response: AxiosResponse) => response.data)
    .then((response: Company) => tranformResponse(response))
}

const createCompany = async (
  company: any
): Promise<{detail?: string; message?: string; status?: string}> => {
  return await axios
    .post(`${COMPANY_URL}/add`, company, {
      validateStatus: () => true,
    })
    .then((response: AxiosResponse<{detail: string}>) => response.data)
    .then((response: {detail: string}) => response)
}

const updateCompany = async (
  company: any
): Promise<{detail?: string; message?: string; status?: string}> => {
  return await axios
    .post(`${COMPANY_URL}/update`, company, {
      validateStatus: () => true,
    })
    .then((response: AxiosResponse<{detail: string}>) => response.data)
    .then((response: {detail: string}) => response)
}

const getDisableCompanyFY = async (id: ID, fy: string): Promise<{detail: string}> => {
  return await axios
    .get(`${COMPANY_URL}/disable/${id}?fy=${fy}`)
    .then((response: AxiosResponse<{detail: string}>) => response.data)
    .then((response: {detail: string}) => response)
}

const deleteCompany = async (
  id: ID
): Promise<{detail?: string; message?: string; status?: string}> => {
  return await axios
    .delete(`${API_URL}/company/delete/${id}`, {
      validateStatus: () => true,
    })
    .then((response: AxiosResponse<{detail: string}>) => response.data)
    .then((response: {detail: string}) => response)
}

const getAddNewFY = async (
  id: ID,
  currency: string,
  exchangeRate: number
): Promise<{detail: string}> => {
  return await axios
    .get(`${COMPANY_URL}/create-new-fy/${id}?currency=${currency}&exchange_rate=${exchangeRate}`)
    .then((response: AxiosResponse<{detail: string}>) => response.data)
    .then((response: {detail: string}) => response)
}

const deleteUser = async (userId: ID): Promise<void> => {
  return await axios.delete(`${USER_URL}/${userId}`).then(() => {})
}

const deleteSelectedUsers = async (userIds: Array<ID>): Promise<void> => {
  const requests = userIds.map((id) => axios.delete(`${USER_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

const getCountriesData = async (country = null, state = null) => {
  // headers['X-CSCAPI-KEY'] = 'RWpVQW1OaTlJWmQweGdaUldUVHRVTVhtUVJwdFl1RGc0eUxUUTE4Tg=='
  const url = `https://api.countrystatecity.in/v1/countries${
    country && !state
      ? `/${country}/states`
      : country && state
      ? `/${country}/states/${state}/cities`
      : ''
  }`
  return await axios
    .get(url, {
      headers: {
        'X-CSCAPI-KEY': 'RWpVQW1OaTlJWmQweGdaUldUVHRVTVhtUVJwdFl1RGc0eUxUUTE4Tg==',
      },
    })
    .then((response) => response.data)
}
export {
  getCompanies,
  deleteUser,
  deleteSelectedUsers,
  getCompanyById,
  getDisableCompanyFY,
  getAddNewFY,
  createCompany,
  updateCompany,
  getCountriesData,
  deleteCompany,
}
